import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=d48ec002&scoped=true&"
import script from "./Examination.vue?vue&type=script&lang=js&"
export * from "./Examination.vue?vue&type=script&lang=js&"
import style0 from "./Examination.vue?vue&type=style&index=0&id=d48ec002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48ec002",
  null
  
)

export default component.exports